import { NetPingDeviceFindDto, type NetPingDeviceFindInterface } from '@zaoblako/shared/modules/pacs/dtos/net-ping-device/net-ping-device-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

import * as yup from 'yup';

/** Converter lock settings - DTO signature */
export interface ConverterLockSettingsFindInterface {
  /** Can converter be locked */
  canLock?: boolean;
  /** Converter unlock delay ({@link DEFAULT_UNLOCK_DELAY} by default) */
  unlockDelay?: number;
  /** Related "NetPing" device */
  netPingDevice?: NetPingDeviceFindInterface;
}

/** Converter lock settings - DTO schema */
export const ConverterLockSettingsFindDto = SerdeDtoClass.create<ConverterLockSettingsFindInterface>(PacsDtoKeysEnum.CONVERTER_LOCK_SETTINGS_FIND_DTO, {
  canLock: {
    optional: true,
    label: 'Можно блокировать',
    hint: 'Если включено, то устройство можно заблокировать: в таком состоянии оно не будет принимать команды от ФРМ',
    serializer: yup.boolean(),
  },
  unlockDelay: {
    optional: true,
    label: 'Задержка перед разблокировкой',
    hint: (
      'Дополнительное время перед разблокировкой устройства в секундах. ' +
      'Задержка может потребоваться для некоторых связанных устройств, чтобы успеть их закрыть (например, шлагбаум).'
    ),
    serializer: yup.number(),
  },
  netPingDevice: {
    optional: true,
    label: 'Датчик блокировки',
    nested: NetPingDeviceFindDto,
    serializer: (_, nested) => nested,
  },
});
